/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Body1Inputs */

const ja_playdata_eventreport_body1 = /** @type {(inputs: Playdata_Eventreport_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指定したeスポーツ大会の詳細分析がPDFレポートとして生成可能です。大会期間中の同時視聴者数の動向や、同時間帯に配信された他のゲームのeスポーツ大会の視聴データ比較分析など、深い洞察を可能にします。`)
};

const en_playdata_eventreport_body1 = /** @type {(inputs: Playdata_Eventreport_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailed analysis of any esports tournament you choose can be generated as a PDF report. Concurrent viewer trends across the event period and comparison against other games' esports tournaments broadcast at the same time make deeper insight possible.`)
};

/**
* | output |
* | --- |
* | "Detailed analysis of any esports tournament you choose can be generated as a PDF report. Concurrent viewer trends across the event period and comparison agai..." |
*
* @param {Playdata_Eventreport_Body1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_body1 = /** @type {((inputs?: Playdata_Eventreport_Body1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Body1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_body1(inputs)
	return en_playdata_eventreport_body1(inputs)
});
export { playdata_eventreport_body1 as "playdata_eventReport_body" }